import { liteClient } from 'algoliasearch/lite';
var _client = null;

/**
 * Returns a shared Algolia liteClient singleton.
 * Reads credentials from `window.algoliaPlp` on first call.
 *
 * @param {{ appId?: string, searchApiKey?: string }} [overrides]
 * @returns {import('algoliasearch/lite').LiteClient}
 */
export function getAlgoliaClient() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (_client) return _client;
  var cfg = window.algoliaPlp || {};
  var appId = overrides.appId || cfg.appId;
  var searchApiKey = overrides.searchApiKey || cfg.searchApiKey;
  if (!appId || !searchApiKey) {
    throw new Error('[Algolia] Missing appId or searchApiKey in window.algoliaPlp');
  }
  _client = liteClient(appId, searchApiKey);
  return _client;
}